import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FileUpload from '@/components/FileUpload/FileUpload';
export default {
  components: {
    FileUpload: FileUpload
  },
  props: {
    AddformData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    systemdata: null
  },
  data: function data() {
    return {
      formHelpDoc: {
        systemId: null,
        fileList: null
      },
      rules: {
        systemId: [{
          required: true,
          message: '请选择系统名称',
          trigger: 'change'
        }],
        fileList: [{
          required: true,
          message: '请上传文档',
          trigger: 'change'
        }]
      },
      fileList: []
    };
  },
  created: function created() {},
  methods: {
    cancelDailog: function cancelDailog() {
      this.$emit('helpFileAddSubmit', {
        bool: false
      });
    },
    // confirmsure(bool){
    //   if(bool){
    //     this.commit();
    //   }
    // },
    uploadSuccess: function uploadSuccess(filelist) {
      var _this = this;
      this.formHelpDoc.fileList = [];
      this.fileList = filelist;
      // eslint-disable-next-line array-callback-return
      this.fileList.filter(function (item) {
        var helpDoc = {
          fileName: item.name,
          filePath: item.response.result
        };
        _this.formHelpDoc.fileList.push(helpDoc);
      });
    },
    commit: function commit() {
      var _this2 = this;
      this.$refs.formHelpDoc.validate(function (valid) {
        if (valid) {
          if (_this2.fileList.length === 0) {
            _this2.$message({
              message: '请上传帮助文档',
              type: 'warning'
            });
            return false;
          }
          var heloDocList = {
            systemId: _this2.formHelpDoc.systemId,
            fileInfoList: _this2.formHelpDoc.fileList
          };
          _this2.$emit('helpFileAddSubmit', {
            bool: true,
            formData: heloDocList
          });
        }
      });
    }
  }
};